module.exports = __webpack_public_path__ + "static/media/Contact.c606f237.png";